export enum CatalogType {
    DOCUMENT_TYPE = "document-types",
    INFORMATION_SYSTEMS = "information-systems",
}
